/**
 * @module
 * @format
 */

import {ARRAY, ENUM, INTEGER, NULLABLE, OBJECT, STRING} from '@acng/frontend-rubicon';

const FEED_TYPE_WEBLOG = 'weblog';
const FEED_TYPE_MOVIE = 'movie';
const FEED_TYPE_PICTURE = 'picture';
const FEED_TYPE_PROFILE_IMAGE = 'profileImage';
const FEED_TYPE_EVENT = 'event';

/**
 * A list of all known feed types.
 */
const FEED_TYPES = /** @type {const} */ ([
  FEED_TYPE_WEBLOG,
  FEED_TYPE_MOVIE,
  FEED_TYPE_PICTURE,
  FEED_TYPE_PROFILE_IMAGE,
  FEED_TYPE_EVENT,
]);

const asFeedItemType = /* @__PURE__ */ ENUM(FEED_TYPES);

/**
 * Validate a feed item.
 */
const asFeedItemData = /* @__PURE__ */ OBJECT({
  id: INTEGER,
  user_id: STRING,
  date: /* @__PURE__ */ NULLABLE(STRING),
  type: asFeedItemType,
});

/**
 * Validate a feed list.
 */
const asFeedData = /* @__PURE__ */ ARRAY(asFeedItemData);

export {
  //
  FEED_TYPE_WEBLOG,
  FEED_TYPE_MOVIE,
  FEED_TYPE_PICTURE,
  asFeedItemType,
  asFeedItemData,
  asFeedData,
};
